export const LOAD_RELAYS = 'LOAD_RELAYS'
export const SET_CURRENT_RELAY_INTERVALS = 'SET_CURRENT_RELAY_INTERVALS'
export const ADD_RELAYS_INTERVALS = 'ADD_RELAYS_INTERVALS'
